module.exports = __webpack_public_path__ + "media/images/not-connected-huge-ping-7ded8bb9d046069550df8f088360ff47.svg";